import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
export const SCRUBBABLE_THUMBNAIL_INDICATOR_WIDTH = 2;
export const VideoScrubbableThumbnail = /*#__PURE__*/ memo((param)=>{
    let { backgroundImageRef, indicatorRef, src, style } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "pointer-events-none absolute inset-0 size-full overflow-hidden rounded-4",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "size-full bg-cover",
                style: {
                    backgroundImage: 'url("'.concat(src, '")'),
                    ...style
                },
                ref: backgroundImageRef
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "pointer-events-none absolute left-0 top-0 hidden h-full bg-blue-9",
                ref: indicatorRef,
                style: {
                    width: SCRUBBABLE_THUMBNAIL_INDICATOR_WIDTH
                }
            })
        ]
    });
});
VideoScrubbableThumbnail.displayName = "VideoScrubbableThumbnail";
